import React from 'react'
import Navbar from './components/Navbar'

function Dashboard() {
  return (
    <div>
        <Navbar/>
      <h1>Dashboard</h1>
    </div>
  )
}

export default Dashboard